import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MultimediaService {
  public urlApi: string;

  constructor(private http: HttpClient) {
    this.urlApi = environment.urlApiImg;
  }

  getPopUp() {
    return this.http.get(`${this.urlApi}/api/popup-imgs/?populate=*`);
  }
}
